import { ICartItem } from "@/types/cart";
import { ISearchObject } from "@/types/search";
import { buildOrderItems } from "@/services/order.service";
import client from './client';
import { IOrderResponse } from '@/types/api-responses';

export async function getOrder(orderId: string) {
    if (!orderId) return null;
    const { data, error } = await client.GET('/api/v1/public/orders/{id}', {
        params: { path: { id: String(orderId) } }
    });
    if (error) return null;
    return (data as unknown as IOrderResponse) || null;
}

export async function addOrder(name: string, phone: string, email: string, obj_id: number, cart: ICartItem[], object: ISearchObject) {
    const itemsPayload = buildOrderItems(object, cart).map(item => ({
        prep_id: item.prep_id,
        name: item.name,
        proizv_name: item.proizv_name,
        quantity: item.quantity,
        min_price: item.min_price,
        price_default: item.price_default
    }));

    const { data, error } = await client.POST('/api/v1/public/orders', {
        body: {
            name,
            phone,
            email,
            obj_id: obj_id,  // ← snake_case
            items: itemsPayload
        }
    });

    if (error) {
        throw new Error(`Ошибка при создании заказа: ${JSON.stringify(error)}`);
    }

    // 201 возвращает числовой id заказа
    return String(data ?? '');
}